package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.carousel.InfiniteCarousel
import com.cybersoftsolution.cybersoftsolutionweb.components.collapse.CollapseContainer
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.text.WritableSpanText
import com.cybersoftsolution.cybersoftsolutionweb.models.Technology
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.collapseQuestions
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Rotate_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.receiveAsFlow
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.Element
import com.varabyte.kobweb.compose.ui.Alignment

@Composable
fun TechnologiesSection(
    pageSection: PageSection,
    technologies: List<Technology>,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    title: String? = null,
) {

    ContentLayout(
        title = title,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier.then(Modifier.transition(Transition.of(property = TransitionProperty.All, duration = 500.ms)))
    ){



        val randomList = technologies.shuffled()

        InfiniteCarousel(
            modifier = Modifier.fillMaxWidth(),
            id = "infiniteCarouselTechnologiesId",
//            items = technologies.shuffled(),
            items = randomList,
            showIndicator = false
        ){ tech ->

                Image(
                    modifier = Scale_Selected_ItemStyle.toModifier()
                        .backgroundColor(Theme.Withe.rgb)
                        .cursor(Cursor.Pointer)
                        .transition(Transition.of(property = TransitionProperty.All, duration = 1000.ms))
                        .aspectRatio(1)
                        .fillMaxWidth(90.px)
                        .borderRadius(15.px)
                        .objectFit(ObjectFit.Cover)
                        .attrsModifier {
                            title(tech.title)
                            attr("type", "button")  ///Necessary if use any other component as toggle object
                            attr("data-bs-toggle", "collapse")
                            attr("data-bs-target", "#${tech.id}")
                            attr("aria-expanded", "false")
                            attr("aria-controls", tech.id?:"")
                        }
                    ,
                    src = tech.image,
                    alt = tech.title,
                )




        }


        CollapseContainer(
            modifier = Modifier
                .margin(topBottom = 12.px),
            id = "technologiesCollapseContainerId",
            elements = technologies,
            useInnerToggleButtons = false
        ){ element ->


            Column(
                horizontalAlignment = if (isDesktop())Alignment.End  else Alignment.CenterHorizontally,
                modifier = Modifier
                    .thenIf(
                        condition = isDesktop(),
                        other = Modifier.alignContent(AlignContent.End)
                    )
            ) {
                SpanText(
                    modifier = Modifier
                        .margin(bottom = 10.px)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Bold),
                    text = element.text
                )
                SpanText(
                    modifier = Modifier
                        .margin(topBottom = 10.px)
                        .color(Theme.HalfBlack.rgb)
                        .fontStyle(FontStyle.Italic),
                    text = element.subtitle
                )

                MyButton(
//                    width = if (isDesktop()) null else 150.px,
                    borderRadius = 35.px,
                    buttonType = MyButtonType.Primary,
                    modifier = Modifier
                        .margin(leftRight = 20.px)
                        .thenIf(
                            condition = !isDesktop(),
                            other = Modifier.fillMaxWidth()
                        )
                        .height(38.px)
                        .transition(Transition.of(property = TransitionProperty.All, duration = 750.ms))
                    ,

                    id = "showMoreAboutTechButtonId",

                    text = " Saber mas ",
                    onClick = {

                    },
                    fontSize = 15
                )

            }



        }



    }


}


